/* eslint-disable react/jsx-fragments */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect, useState } from 'react';
import {
  Button,
  Container,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
} from 'reactstrap';
import history from '../../router/history';
import {
  ADMIN,
  LOVEBOX,
  POSTCARD,
  SEND,
} from '../../assets/Images';
import RelationFeed from './relation-feed';

const RelationBox = ({ box, email }) => (
  <Col xs="6">
    <Card body>
      <CardTitle tag="h5">
        Box Info
      </CardTitle>
      <CardText>
        <div>
          <b>Lovebox name:</b> {box.nickname}
        </div>
        <div>
          <b>Pairing code:</b> {box.pairingCode}
        </div>
        <div>
          <b>Is admin:</b> {`${box.isAdmin}`}
        </div>
        <div>
          <b>Has Color:</b> {`${box.hasColor}`}
        </div>
        {box.hardware && (
        <div>
          <b>Hardware version:</b> {`${box.hardware.startsWith('C') ? 'V2' : 'V1'} (${box.hardware})`}
        </div>
        )}
        <Button href={`/lovebox/${email}/${box._id.slice(0, 5)}`}>Open Lovebox Infos</Button>
      </CardText>
    </Card>
  </Col>
);

const Relation = ({
  email, box,
}) => (
  <Container>
    <Row>
      {box && (
        <RelationBox box={box} email={email} />
      )}
    </Row>
  </Container>
);

const RelationsList = ({
  boxes = [], onSelect, selectedId,
}) => {
  const list = boxes.map((box) => (
    <ListGroupItem
      tag="button"
      active={box._id === selectedId}
      onClick={() => onSelect(box._id)}
      key={box._id}
    >
      {box.nickname}
      {' '}
      {box._id && (
        <img
          alt=""
          src={LOVEBOX}
          width="7%"
        />
      )}
      { box._id && box.isAdmin && (
        <img
          alt=""
          src={ADMIN}
          width="7%"
        />
      )}
    </ListGroupItem>
  ));

  return (
    <ListGroup>
      {list}
      <ListGroupItem
        tag="button"
        active={selectedId === 'POSTCARD'}
        onClick={() => onSelect('POSTCARD')}
      >
        {'Postcard'}
        {' '}
        <img
          alt=""
          src={POSTCARD}
          width="6%"
        />
      </ListGroupItem>
      <ListGroupItem
        tag="button"
        active={selectedId === 'SHARED'}
        onClick={() => onSelect('SHARED')}
      >
        {'Shared'}
        {' '}
        <img
          alt=""
          src={SEND}
          width="6%"
        />
      </ListGroupItem>
    </ListGroup>
  );
};
const UserRelationsTable = ({
  boxes, urlRelation: relationIdFromUrl, email, userId,
}) => {
  const [selectedChannel, setSelectedChannel] = useState('');

  useEffect(() => {
    if (boxes.length > 0) {
      updateSelectedChannel(relationIdFromUrl || boxes[0]._id);
    }
  }, [boxes, relationIdFromUrl]);

  const updateSelectedChannel = (channelId) => {
    if (channelId) {
      if (['POSTCARD', 'SHARED'].includes(channelId)) {
        setSelectedChannel(channelId);
        history.push({ pathname: `/user/${email}/${channelId}` });
      }
      const box = boxes.find((userBox) => (
        [userBox._id, userBox.macAddress].includes(channelId)
      ));
      if (box) {
        setSelectedChannel(channelId);
        history.push({ pathname: `/user/${email}/${channelId}` });
      }
    }
  };

  return (
    <Container>
      <Row>
        <Col xs="4">
          <RelationsList
            onSelect={updateSelectedChannel}
            selectedId={selectedChannel}
            boxes={boxes}
          />
        </Col>
        <Col xs="8">
          {selectedChannel && (
            <Relation
              box={boxes.find((userBox) => (
                [userBox._id, userBox.macAddress].includes(selectedChannel)
              ))}
              email={email}
            />
          )}
        </Col>
      </Row>
      <Row className="mt-4">
        {selectedChannel && (
          <RelationFeed channelId={selectedChannel} userId={userId} />
        )}
      </Row>
    </Container>
  );
};

const UserRelations = ({
  boxes, urlRelation, email, userId,
}) => (
  <Container>
    <Card>
      <CardBody>
        <CardTitle>
          User relations
        </CardTitle>
        <UserRelationsTable
          boxes={boxes}
          urlRelation={urlRelation}
          email={email}
          userId={userId}
        />
      </CardBody>
    </Card>
  </Container>
);

export default UserRelations;



// WEBPACK FOOTER //
// ./src/components/user-info/user-relations.js